import './styles/globals.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AppProvider } from './context/AppContext';
import ErrorBoundary from './components/ErrorBoundary';
const isProduction = process.env.NODE_ENV === 'production' || 
                    process.env.REACT_APP_ENV === 'production' ||
                    window.location.hostname !== 'localhost';

if (isProduction) {
  // Metodo 1: Sovrascrittura diretta
  console.log = function() {};
  console.debug = function() {};
  console.info = function() {};
  
  // Metodo 2: Se il primo non funziona, usa questo
  const noop = () => {};
  ['log', 'debug', 'info'].forEach(method => {
    console[method] = noop;
  });
  
  // Conferma (questo apparirà solo in prod)
  console.error('🔥 Console logs disabilitati per produzione');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AppProvider>
        <App />
      </AppProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// Registra il service worker per funzionalità offline
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registrato con successo:', registration);
      })
      .catch(error => {
        console.error('Errore durante la registrazione del Service Worker:', error);
      });
  });
}